import React, { useMemo, Suspense, useCallback } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Circles } from "react-loader-spinner";
import CryptoJS from "crypto-js";
import getDecryptedToken from "./api/getDecryptedToken";
import PayhereSucces from "./pages/payhere/PayhereSucces";
import PayhereCancel from "./pages/payhere/PayhereCancel";
import PayhereError from "./pages/payhere/PayhereError";
import PaymentData from "./views/paymentView/PaymentData";
import SmsTopUpPage from "./pages/sms/SmsTopUpPage";
import MyAccount from "./pages/myaccount/MyAccount";
import MyAccountTabOutlet from "./pages/myaccount/MyAccountTabOutlet";
import { DEFAULT_ACCOUNT_TAB } from "./pages/myaccount/accountConfig";
import CommonLayout from "./layouts/commonLayout/CommonLayout";
import SuperAdminRoute from "./components/auth/SuperAdminRoute";
import ClientPaymentGate from "./components/auth/ClientPaymentGate";
import Layouts from "./layouts/layoutnew/Layouts";
import { NEWROUTES } from "./utils/routes/new.routes";
import {
  renderRoutes,
  useActiveClientRoutes,
} from "./utils/routing/renderRoutes";
import Drlogin from "./views/maillogin/Drlogin";
import NextQueue from "./pages/nextQueue/NextQueue";
const Login = React.lazy(() => import("./views/login/Login"));
const Bill = React.lazy(() => import("./views/bill/Bill"));

const Printtest = React.lazy(
  () => import("./pages/setting/manageprint/ManagePrint")
);
const PatientSummaryPage = React.lazy(
  () => import("./pages/patient/PatientSummaryPage")
);
const routePermission: string | null = localStorage.getItem("routePermission");
let permissionRoutes: number[] | undefined;
if (routePermission) {
  try {
    permissionRoutes = CryptoJS.AES.decrypt(
      routePermission,
      process.env.REACT_APP_SECRET || "sfdsfasdfsdf3434$$$"
    )
      .toString(CryptoJS.enc.Utf8)
      .split(",")
      .map(Number);
  } catch (error) {
    console.error("Error decrypting routePermission:", error);
  }
}
const decrypteduser: string | undefined = getDecryptedToken("user");
const featureLabsEnabled = getDecryptedToken("featureLabs") === "true";
const featureRoomAllocationEnabled =
  getDecryptedToken("featureRoomAllocation") === "true";

function applyClinicFeatureFilters(routes: any[]) {
  return routes
    .filter((route) => featureLabsEnabled || route.KEY !== 11)
    .map((route) => {
      if (!route.SUBNAV?.length) return route;
      const SUBNAV = route.SUBNAV.filter(
        (sub: any) => featureRoomAllocationEnabled || sub.KEY !== 63
      );
      return { ...route, SUBNAV };
    });
}

function App() {
  const filterByIds = useCallback((array: any, ids: any) => {
    return array?.reduce((filtered: any, item: any) => {
      // Check both accessRoute.KEY (for ALLROUTES) and KEY (for NEWROUTES)
      const itemKey = item?.accessRoute?.KEY || item?.KEY;
      if (ids?.includes(itemKey)) {
        const newItem = { ...item };
        // Handle both subnav (lowercase for ALLROUTES) and SUBNAV (uppercase for NEWROUTES)
        if (item.subnav) {
          newItem.subnav = filterByIds(item?.subnav, ids);
        }
        if (item.SUBNAV) {
          newItem.SUBNAV = filterByIds(item?.SUBNAV, ids);
        }
        filtered.push(newItem);
      }
      return filtered;
    }, []);
  }, []);



  const filteredNewRoutes = useMemo(
    () => applyClinicFeatureFilters(filterByIds(NEWROUTES, permissionRoutes)),
    [filterByIds]
  );
  const activeClientRoutes = useActiveClientRoutes(filteredNewRoutes);

  return (
    <>
      <BrowserRouter>
        <Suspense
          fallback={
            <Circles
              height="80"
              width="80"
              color="#174d7a"
              ariaLabel="bars-loading"
              wrapperStyle={{
                position: "fixed",
                inset: "0",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              wrapperClass=""
            />
          }
        >
          <Routes>
            <Route path="/print/:ID" element={<Printtest />} />
            <Route path="/invoice" element={<Bill />} />
            <Route path="/login" element={<Drlogin />} />
            <Route path="/drlogin" element={<Login />} />
            {/* Patient queue display (wall / TV): static paths must be listed before /room/:roomId */}
            <Route path="/room" element={<NextQueue />} />
            <Route path="/room/all" element={<NextQueue />} />
            <Route path="/room/custom" element={<NextQueue />} />
            <Route path="/room/:roomId" element={<NextQueue />} />
            <Route
              path="my-account"
              element={
                <SuperAdminRoute>
                  <CommonLayout>
                    <MyAccount />
                  </CommonLayout>
                </SuperAdminRoute>
              }
            >
              <Route index element={<Navigate to={DEFAULT_ACCOUNT_TAB} replace />} />
              <Route path=":tab" element={<MyAccountTabOutlet />} />
            </Route>
            {decrypteduser === "client" && (
              <Route element={<ClientPaymentGate />}>
                <Route path="/" element={<Navigate to="/client" />} />
                <Route
                  path="/client"
                  element={<Layouts routes={filteredNewRoutes} />}
                >
                  <Route path="/client" element={<Navigate to="dashboard" />} />
                  {renderRoutes(activeClientRoutes, "/client/")}
                </Route>
                <Route
                  path="/client/patient-summary/:patientId"
                  element={<PatientSummaryPage />}
                />
                <Route path="/client/pay" element={<PaymentData />} />
                <Route path="/client/sms-topup" element={<SmsTopUpPage />} />
                <Route
                  path="/client/payment/success"
                  element={<PayhereSucces />}
                />
                <Route
                  path="/client/payment/cancel"
                  element={<PayhereCancel />}
                />
                <Route
                  path="/client/payment/error"
                  element={<PayhereError />}
                />
              </Route>
            )}



            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}

export default App;
